export type OriginalStimulusTypes =
	| "READING"
	| "LISTENING"
	| "WRITING"
	| "SPEAKING"
	| "ACADEMIC_DISCUSSION_STIMULUS"
	| "LS_STIMULUS"
	| "RLS_STIMULUS"
	| "INDEPENDENT_SPEAKING_STIMULUS"
	| "INTEGRATED_WRITING_STIMULUS";

export type SkillTypes = "READING" | "LISTENING" | "WRITING" | "SPEAKING";

export type OriginalItemTypes =
	| "PASSAGE"
	| "ITEM"
	| "MCQ"
	| "MCSS"
	| "MCSSH"
	| "MCMS"
	| "MCMSH"
	| "INSERT_TEXT"
	| "MATCH_MS"
	| "MCSSM"
	| "MCMSM"
	| "MCGS"
	| "MCOS"
	| "AUDIO_INPUT"
	| "ACADEMIC_DISCUSSION_RESPONSE"
	| "INTEGRATED_WRITING_RESPONSE"
	| "LISTENING_REPLAY"
	| "NOTE_COMPLETION"
	| "STORY_TELLING"
	| "LONG_TURN"
	| "WRITING_EMAIL"
	| "NOTICE_MCQ"
	| "LEXICAL_CLOZE"
	| "PASSAGE_QUESTION"
	| "READING_MCQ"
	| "READING_MULTIPLE_CHOICE_CLOZE"
	| "READING_OPEN_CLOZE"
	| "READING_NOTE_COMPLETION"
	| "READING_PASSAGE_MCQ"
	| "LISTENING_DISCRETE_MCQ"
	| "LISTENING_NOTE_COMPLETION"
	| "LISTENING_MCQ"
	| "HIGHLIGHT_INCORRECT_WORDS"
	| "READING_FILL_IN_THE_BLANKS_DRAG_DROP"
	| "SPEAKING_SHORT_RESPONSE"
	| "SPEAKING_RESPONSE"
	| "SPEAKING_READ_ALOUD"
	| "SPEAKING_EXTENDED_RESPONSE"
	| "WRITING_EXTENDED_RESPONSE"
	| "WRITING_INTEGRATED_RESPONSE"
	| "WRITING_RESPONSE"
	| "ASQSW"
	| "DISW"
	| "FIBDDR"
	| "FIBDPR"
	| "FIBTIL"
	| "HCSL"
	| "HIWL"
	| "MCMAL"
	| "MCMAR"
	| "MCSAL"
	| "MCSAR"
	| "PISW"
	| "RASW"
	| "ROPR"
	| "RSSW"
	| "RTSSW"
	| "RLSW"
	| "SMWL"
	| "SGDL"
	| "SSTL"
	| "SWTR"
	| "WEMSW"
	| "WESW"
	| "WFDL"
	| "ASQSW_CORE"
	| "DISW_CORE"
	| "FIBDDR_CORE"
	| "FIBDPR_CORE"
	| "FIBTIL_CORE"
	| "HCSL_CORE"
	| "HIWL_CORE"
	| "MCMAL_CORE"
	| "MCMAR_CORE"
	| "MCSAL_CORE"
	| "MCSAR_CORE"
	| "PISW_CORE"
	| "RASW_CORE"
	| "ROPR_CORE"
	| "RSSW_CORE"
	| "RTSSW_CORE"
	| "SMWL_CORE"
	| "SSTL_CORE"
	| "SWTR_CORE"
	| "WEMSW_CORE"
	| "WFDL_CORE"
	| "answer_short_question"
	| "describe_image"
	| "fill_in_the_blanks_type_in"
	| "highlight_correct_summary"
	| "highlight_incorrect_words"
	| "mcq_multiple_listening"
	| "mcq_multiple_reading"
	| "mcq_single_listening"
	| "mcq_single_reading"
	| "personal_introduction"
	| "read_aloud"
	| "reading_fill_in_the_blanks_drag_and_drop"
	| "reading_fill_in_the_blanks_dropdown"
	| "reorder_paragraphs"
	| "repeat_sentence"
	| "respond_to_a_situation"
	| "retell_lecture"
	| "select_missing_word"
	| "summarize_group_discussion"
	| "summarize_spoken_text"
	| "write_from_dictation"
	| "write_email"
	| "write_essay"
	| "select_single"
	| "select_multiple"
	| "select_input"
	| "text_input"
	| "type_in"
	| "word_selection"
	| "ordering"
	| "drag_drop"
	| "summarize_written_text"
	| "BLANK_DROPDOWN"
	| "BLANK_DRAG_WORD"
	| "MATCHING_PAIR"
	| "SINGLE_SELECT"
	| "MULTI_SELECT"
	| "INTRO_SCREEN"
	| "PERSONAL_INTRODUCTION";

export type IntroScreenType =
	| "CHECKLIST"
	| "MIC_CHECK"
	| "FULL_TEST_FORMAT"
	| "READY_TO_START"
	| "PART_TEST_FORMAT";

export type SourceMetadataItemTypes =
	| OriginalItemTypes
	| "answer_short_question"
	| "describe_image"
	| "fill_in_the_blanks_type_in"
	| "highlight_correct_summary"
	| "highlight_incorrect_words"
	| "mcq_multiple_listening"
	| "mcq_multiple_reading"
	| "mcq_single_listening"
	| "mcq_single_reading"
	| "personal_introduction"
	| "read_aloud"
	| "reading_fill_in_the_blanks_drag_and_drop"
	| "reading_fill_in_the_blanks_dropdown"
	| "reorder_paragraphs"
	| "repeat_sentence"
	| "respond_to_a_situation"
	| "retell_lecture"
	| "select_missing_word"
	| "summarize_group_discussion"
	| "summarize_spoken_text"
	| "write_from_dictation"
	| "write_email"
	| "write_essay"
	| "select_single"
	| "select_multiple"
	| "select_input"
	| "text_input"
	| "type_in"
	| "word_selection"
	| "ordering"
	| "drag_drop"
	| "summarize_written_text"
	| "ASQSW"
	| "DISW"
	| "FIBDDR"
	| "FIBDPR"
	| "FIBTIL"
	| "HCSL"
	| "HIWL"
	| "MCMAL"
	| "MCMAR"
	| "MCSAL"
	| "MCSAR"
	| "PISW"
	| "RASW"
	| "ROPR"
	| "RSSW"
	| "RTSSW"
	| "RLSW"
	| "SMWL"
	| "SGDL"
	| "SSTL"
	| "SWTR"
	| "WEMSW"
	| "WESW"
	| "WFDL";

export type SessionType = "FORMATIVE" | "SUMMATIVE";
